import { Grid } from "@mui/material";
import { FC, ReactNode } from "react";

export type FieldGridContainerProps = {
  children: ReactNode;
};

/**
 * Generic component to render a consistent form grid component for responsiveness
 * @param pass the children
 * @returns Renders a uniform react spacing for grid items of textfield type in a responsive way
 */
const FieldGridContainer: FC<FieldGridContainerProps> = ({ children }) => {
  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      {children}
    </Grid>
  );
};

export default FieldGridContainer;
